import { render, staticRenderFns } from "./ModalEmailDeconnected.vue?vue&type=template&id=6b836077&scoped=true&"
import script from "./ModalEmailDeconnected.vue?vue&type=script&lang=js&"
export * from "./ModalEmailDeconnected.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmailDeconnected.vue?vue&type=style&index=0&id=6b836077&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b836077",
  null
  
)

component.options.__file = "ModalEmailDeconnected.vue"
export default component.exports